import React from "react";
import { PageProps } from "../Page";
import FormConfiguration from "./FormConfiguration";
import { IFormConfigurationPresenter } from "../../../presenter/formconfiguration/FormConfigurationPresenter";
import { Spin } from "antd";
import { IFormType } from "../../../model/formconfiguration/FormType";

export interface Props extends PageProps {}
export interface State extends IFormConfigurationPresenter {}

export default class FormConfigurationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      formType,
      createFormSection,
      formSections,
      updateFormSection,
      invalidateFormSection,
      setSelectedFormElement,
      selectedFormElement,
      createFormConfigSectionQualifier,
      qualifiers,
      updateFormConfigSectionQualifier,
      invalidateQualifier,
      createFormConfigQualifierAttribute,
      attributes,
      updateFormConfigQualifierAttribute,
      invalidateAttribute,
      isSelectedComponent,
      formParamsBoxVisible,
      hideFormParamsBox
    } = this.state;

    return (
      <Spin
        spinning={this.state.loaders.formConfigurationLoader}
        tip={translate("spin.text")}
        className={"display-spin"}
      >
        <Spin
          spinning={this.state.loaders.updateFormConfigurationLoader || false}
          tip={translate("spin.update_text")}
          className={"display-spin"}
        >
          <FormConfiguration
            formTitle={formType ? formType.name : ""}
            formSections={formSections}
            translate={translate}
            createSection={createFormSection}
            updateSection={updateFormSection}
            removeSection={invalidateFormSection}
            setSelectedFormElement={setSelectedFormElement}
            selectedFormElement={selectedFormElement}
            createFormConfigSectionQualifier={createFormConfigSectionQualifier}
            qualifiers={qualifiers}
            updateFormConfigSectionQualifier={updateFormConfigSectionQualifier}
            invalidateQualifier={invalidateQualifier}
            createFormConfigQualifierAttribute={
              createFormConfigQualifierAttribute
            }
            attributes={attributes}
            updateFormConfigQualifierAttribute={
              updateFormConfigQualifierAttribute
            }
            invalidateAttribute={invalidateAttribute}
            isSelectedComponent={isSelectedComponent}
            loading={this.state.loaders.formConfigurationLoader}
            formParamsBoxVisible={formParamsBoxVisible}
            hideFormParamsBox={hideFormParamsBox}
            formType={formType || ({} as IFormType)}
          />
        </Spin>
      </Spin>
    );
  }
}
